export default {"id":"6838bd29","attrs":{"viewBox":"0 0 24 24","width":"24","height":"24"}}